const SectionTitle = ({
  sectionNameClass,
  sectionTitle,
  sectionDescription,
  showCount,
  count,
}) => {
  return (
    <div className={`${sectionNameClass}`}>
      {/* col-lg-7 text-left commonTitleText */}
      <h5>{sectionTitle}</h5>
      {sectionDescription && (
        <div dangerouslySetInnerHTML={{ __html: sectionDescription }} />
      )}
    </div>
    // <h3 className="card-title m-0 p-0 border-2 font-weight-bolder text-dark text-size-16">
    //   {titleName}
    //   {showCount === true && (
    //     <span
    //       className="label label-dark ml-2 text-white font-weight-bold w-30px h-30px"
    //       style={{ fontSize: "11px" }}
    //     >
    //       {count ? count : 0}
    //     </span>
    //   )}
    // </h3>
  );
};

export default SectionTitle;
